<template>
  <modal @closed="$modal.hide('satelliteInstall')" :width="680" name="satelliteInstall" height="auto" :scrollable="true" classes="creative-modal" :shiftY="0">
    <div class="modal-content satellite-install">
      <button type="button" class="close" @click="$modal.hide('satelliteInstall')">
        <span aria-hidden="true"><svg v-svg symbol="x" size="0 0 17 17" /></span>
      </button>
      <div class="modal-body">
        <div class="title-h2 pb-2">
          {{ $t("satellites.install_title") }}
        </div>
        <p class="satellite-install__text">
          {{ $t("satellites.install_text") }}
        </p>
        <div class="code satellite-install__code">
          <div class="hidden">
            <textarea readonly id="satelliteInstallCommand" :value="command" />
          </div>
          <button type="button" class="btn _has-icon satellite-install__copy" @click="copy">
            <span class="icon-copy">
              <svg v-svg symbol="copy" size="0 0 13 15" role="info" />
            </span>
            {{ $t("copy") }}
          </button>
          <code class="code__content">{{ command }}</code>
        </div>
        <ul class="satellite-install__req">
          <li>{{ $t("satellites.req_root") }}</li>
          <li>{{ $t("satellites.req_os") }}</li>
          <li>{{ $t("satellites.req_ports") }}</li>
        </ul>
      </div>
    </div>
  </modal>
</template>
<script>
import "@/assets/css/_code.scss";
import "@/assets/css/_modal.scss";

export default {
  name: "InstallCommandModal",
  props: {
    command: {
      type: String,
      default: "",
    },
  },
  methods: {
    copy() {
      if (!this.command) return;
      const done = () => {
        this.$alert({
          type: "success",
          title: this.$t("copied_succ"),
        });
      };
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(this.command).then(done);
      } else {
        this.$helper.copyCode("satelliteInstallCommand");
        done();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.satellite-install {
  border: none;
  border-radius: 20px;

  &__text {
    font-size: 15px;
    line-height: 1.5;
    color: #5d5d6b;
    margin-bottom: 20px;
  }

  &__code {
    margin-bottom: 24px;

    .code__content {
      white-space: pre-wrap;
      word-break: break-all;
      padding: 64px 20px 24px;
      font-size: 14px;
      line-height: 1.6;
    }
  }

  &__copy {
    position: absolute;
    top: 12px;
    right: 12px;
    height: 40px;
    padding: 0 18px;
    display: inline-flex;
    align-items: center;

    .icon-copy {
      display: inline-flex;
      margin-right: 8px;
    }
  }

  &__req {
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-size: 14px;
    color: #5d5d6b;

    li {
      position: relative;
      padding-left: 18px;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 7px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #37807d;
      }
    }
  }
}

body.dark .satellite-install {
  &__text,
  &__req {
    color: #b7b7b7;
  }
}
</style>
